<template>
    <div class="main-content">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Produtos</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold text-dark">Gestão de Itens</h4>
                    <span class="text-muted fs-7">Exibindo {{ products.length }} de {{ totalItems }}</span>
                </div>
                <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3" @click="confirmDelete(null, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{ selectedIds.length }})
                            </button>
                        </div>
                    </transition>

                    <div class="dropdown me-2 pe-3 border-end">
                        <button class="btn btn-pmg-light dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-printer me-1"></i> Relatórios / Ferramentas
                        </button>
                        <ul class="dropdown-menu shadow border-0 py-2">
                            <li>
                                <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Exportar Dados</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('pdf')">
                                    <i class="bi bi-file-earmark-pdf text-danger me-2"></i> Relatório Geral (PDF)
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('xlsx')">
                                    <i class="bi bi-file-earmark-excel text-success me-2"></i> Planilha Completa (Excel)
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider opacity-10">
                            </li>
                            <li>
                                <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Ferramentas</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openImportModal">
                                    <i class="bi bi-cloud-arrow-up text-primary me-2"></i> Importar Produtos
                                </a>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-pmg-light" @click="refreshData" :disabled="loading" title="Atualizar tela">
                        <i class="bi bi-arrow-clockwise" :class="{ 'spin-animation': loading }"></i>
                    </button>
                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <button class="btn btn-pmg-primary" @click="openModal('create')">
                        <i class="bi bi-plus-lg me-1"></i> Novo Produto
                    </button>
                </div>
            </div>
            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3 shadow-sm">
                    <div class="row g-2 align-items-end">
                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Pesquisar</label>
                            <input v-model="filter.search" type="text" class="form-control form-control-pmg"
                                placeholder="Nome, Código (SKU) ou descrição..." @keyup.enter="applyFilter">
                        </div>

                        <div class="col-md-2">
                            <label class="form-label small fw-bold text-muted">Categoria</label>
                            <select v-model="filter.category_id" class="form-select form-control-pmg"
                                @change="applyFilter">
                                <option value="">Todas</option>
                                <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label class="form-label small fw-bold text-muted">Perecível</label>
                            <select v-model="filter.is_perishable" class="form-select form-control-pmg"
                                @change="applyFilter">
                                <option value="ALL">Todos</option>
                                <option value="YES">Sim</option>
                                <option value="NO">Não</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label class="form-label small fw-bold text-muted">Perigoso</label>
                            <select v-model="filter.is_hazardous" class="form-select form-control-pmg"
                                @change="applyFilter">
                                <option value="ALL">Todos</option>
                                <option value="YES">Sim</option>
                                <option value="NO">Não</option>
                            </select>
                        </div>

                        <div class="col-md-2 d-flex gap-2">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold py-3" @click="applyFilter">
                                <i class="bi bi-search"></i> Filtrar
                            </button>
                            <button class="btn btn-outline-danger py-1" @click="clearFilters" title="Limpar Filtros">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-container">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 35%">Produto</th>
                            <th style="width: 15%">Código(SKU)</th>
                            <th style="width: 10%">Preço</th>
                            <th style="width: 15%">Estoque</th>
                            <th style="width: 10%" class="text-end">Ações</th>
                        </tr>
                    </thead>
                    <tbody v-if="products.length > 0">
                        <tr v-for="item in products" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td><input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>

                            <td @click.prevent="openViewModal(item)" class="pointer">
                                <div class="fw-bold text-dark">{{ item.name }}</div>
                                <div class="small text-muted">{{ item.category?.name || 'Sem Categoria' }}</div>
                            </td>
                            <td class="text-muted small">{{ item.sku }}</td>
                            <td class="fw-medium text-dark">{{ formatCurrency(item.price) }}</td>
                            <td>
                                <!-- 1. Alerta do Estoque Geral (Calculado de forma dinâmica ou mantido como indicador geral) -->
                                <div class="mb-1 d-flex align-items-center">
                                    <!-- Opcional: Se quiser alertar caso o estoque total seja menor que a soma dos estoques mínimos das filiais -->
                                    <span
                                        :class="isGlobalStockCritical(item) ? 'badge bg-danger-subtle text-danger' : 'text-dark fw-bold'"
                                        class="px-2 py-1 rounded fs-6">
                                        {{ item.stock || 0 }} {{ item.unit_of_measure }}
                                   
                                         <span class="text-muted ms-1" style="font-size: 0.75rem; text-transform: uppercase;">Total</span>
                                     </span>
                                </div>

                                <!-- 2. Estoque e Alertas individuais de cada Filial -->
                                <div class="d-flex flex-wrap gap-1 mt-1">
                                    <template v-if="item.branches && item.branches.length > 0">

                                        <!-- Loop das duas primeiras filiais -->
                                        <div v-for="branch in item.branches.slice(0, 2)" :key="branch.id"
                                            :class="Number(branch.pivot.stock) <= Number(branch.pivot.min_stock)
                                                ? 'badge bg-danger-subtle border border-danger text-danger fw-bold d-flex align-items-center px-2 py-1 shadow-sm'
                                                : 'badge bg-white border border-light-subtle text-muted fw-medium d-flex align-items-center px-2 py-1 shadow-sm'" style="font-size: 0.75rem;">

                                            <i class="bi bi-shop me-1 opacity-75"
                                                :class="Number(branch.pivot.stock) <= Number(branch.pivot.min_stock) ? 'text-danger' : 'text-primary'"></i>
                                            <span class="text-truncate d-inline-block" style="max-width: 90px;"
                                                :title="branch.name">
                                                {{ branch.name }}
                                            </span>:
                                            <strong class="ms-1"
                                                :class="Number(branch.pivot.stock) <= Number(branch.pivot.min_stock) ? 'text-danger' : 'text-dark'">
                                                {{ branch.pivot.stock }}
                                            </strong>
                                            <!-- Mostra o estoque mínimo de forma discreta ao lado -->
                                            <span class="text-muted opacity-50 ms-0.5" style="font-size: 0.65rem;margin-left: 5px;">(mín:
                                                {{ parseInt(branch.pivot.min_stock) }})</span>
                                        </div>

                                        <!-- Dropdown para mais de 2 filiais -->
                                        <div class="dropdown" v-if="item.branches.length > 2">
                                            <div class="badge bg-light border border-light-subtle text-primary fw-bold d-flex align-items-center px-2 py-1 shadow-sm"
                                                style="font-size: 0.65rem; cursor: pointer;" data-bs-toggle="dropdown"
                                                data-bs-boundary="viewport">
                                                +{{ item.branches.length - 2 }} lojas <i
                                                    class="bi bi-chevron-down ms-1"></i>
                                            </div>

                                            <ul class="dropdown-menu shadow-sm border-0 p-2"
                                                style="min-width: 210px; font-size: 0.75rem;">
                                                <li v-for="branch in item.branches.slice(2)" :key="branch.id"
                                                    class="d-flex justify-content-between align-items-center py-1 px-2 border-bottom border-light">
                                                    <span class="text-muted text-truncate me-2"
                                                        style="max-width: 110px;" :title="branch.name">
                                                        <i class="bi bi-shop me-1 opacity-50"></i> {{ branch.name }}
                                                    </span>
                                                    <div class="d-flex align-items-center gap-1">
                                                        <strong
                                                            :class="Number(branch.pivot.stock) <= Number(branch.pivot.min_stock) ? 'text-danger' : 'text-dark'">
                                                            {{ branch.pivot.stock }}
                                                        </strong>
                                                        <span class="text-muted opacity-50" style="font-size: 0.6rem;">/
                                                            {{ parseInt(branch.pivot.min_stock) }}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                    </template>
                                    <span v-else class="text-muted opacity-50" style="font-size: 0.65rem;">
                                        Sem alocação
                                    </span>
                                </div>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        data-bs-boundary="viewport">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0">
                                        <li><a class="dropdown-item fw-bold text-primary" href="#"
                                                @click.prevent="openStockModal(item)"><i
                                                    class="bi bi-box-seam me-2"></i>Movimentar Estoque</a></li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li><a class="dropdown-item fw-medium" href="#"
                                                @click.prevent="openViewModal(item)"><i class="bi bi-eye me-2"></i>Ver
                                                Detalhes</a></li>
                                        <li><a class="dropdown-item fw-medium" href="#"
                                                @click.prevent="openAuditModal(item)"><i
                                                    class="bi bi-clock-history me-2"></i>Histórico de Alterações</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item fw-medium" href="#"
                                                @click.prevent="openHistoryModal(item)">
                                                <i class="bi bi-list-check me-2"></i>Ver Extrato de Estoque
                                            </a>
                                        </li>
                                        <li><a class="dropdown-item" href="#"
                                                @click.prevent="openModal('edit', item)"><i
                                                    class="bi bi-pencil me-2"></i>Editar Produto</a></li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li><a class="dropdown-item text-danger" href="#"
                                                @click.prevent="confirmDelete(item)"><i
                                                    class="bi bi-trash me-2"></i>Excluir</a></li>

                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="8" class="text-center py-5 text-muted">
                                <i class="bi bi-inbox fs-1 mb-2 opacity-50"></i><br>
                                <span>Nenhum produto encontrado.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center mt-4" v-if="hasMore">
                <button class="btn btn-pmg-light px-5 btn-sm fw-bold" @click="loadMore" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    <span>{{ loading ? 'Carregando...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <div class="modal fade" id="modalViewProduct" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <h5 class="fw-bold m-0 text-dark">Detalhes do Produto</h5>
                        <button type="button" class="btn-close" @click="closeViewModal"></button>
                    </div>
                    <div class="modal-body p-4" v-if="selectedProductView">
                        <div class="row g-4">
                            <div class="col-md-12">
                                <h6 class="fw-bold text-uppercase text-muted small mb-3 border-bottom pb-2">Informações
                                    Gerais</h6>
                                <div class="row g-3">
                                    <div class="col-sm-8">
                                        <span class="d-block small text-muted">Nome</span>
                                        <span class="fw-bold fs-5">{{ selectedProductView.name }}</span>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">SKU</span>
                                        <span class="fw-bold">{{ selectedProductView.sku }}</span>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Categoria</span>
                                        <span class="fw-medium">{{ selectedProductView.category?.name || 'Geral'
                                        }}</span>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Preço</span>
                                        <span class="fw-bold text-success">{{ formatCurrency(selectedProductView.price)
                                        }}</span>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Estoque Atual / Mínimo</span>
                                        <span class="fw-bold">{{ selectedProductView.stock }} / {{
                                            selectedProductView.min_stock }} {{ selectedProductView.unit_of_measure
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <h6 class="fw-bold text-uppercase text-muted small mb-3 border-bottom pb-2">Vitrine e
                                    E-commerce
                                </h6>
                                <div class="row g-3">
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Preço de Custo</span>
                                        <span class="fw-medium text-dark">{{
                                            formatCurrency(selectedProductView.cost_price || 0)
                                        }}</span>
                                    </div>
                                    <div class="col-sm-8">
                                        <span class="d-block small text-muted">Descrição Comercial</span>
                                        <span class="fw-medium text-dark">{{ selectedProductView.description || 'Não informada.'}}</span>
                                    </div>
                                    <div class="col-sm-12">
                                        <span class="d-block small text-muted">Especificações Técnicas</span>
                                        <span class="fw-medium text-dark">{{ selectedProductView.technical_description || 'Não informada.' }}</span>
                                    </div>
                                </div>
                                <div v-if="selectedProductView.images && selectedProductView.images.length > 0"
                                    class="mt-3">
                                    <span class="d-block small text-muted mb-2">Fotos do Produto</span>
                                    <div class="d-flex flex-wrap gap-2">
                                        <img v-for="(img, idx) in selectedProductView.images" :key="idx" :src="img"
                                            class="border rounded-3 object-fit-cover shadow-sm"
                                            style="width: 80px; height: 80px;">
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <h6 class="fw-bold text-uppercase text-muted small mb-3 border-bottom pb-2">Logística e
                                    Armazenagem</h6>
                                <div class="row g-3">
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Peso</span>
                                        <span class="fw-medium">{{ selectedProductView.weight || '-' }} kg</span>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Dimensões</span>
                                        <span class="fw-medium">{{ selectedProductView.dimensions || '-' }}</span>
                                    </div>
                                    <div class="col-sm-4">
                                        <span class="d-block small text-muted">Localização no Estoque</span>
                                        <span class="fw-medium text-primary">{{ selectedProductView.storage_location ||
                                            'Não definida' }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <h6 class="fw-bold text-uppercase text-muted small mb-3 border-bottom pb-2">
                                    Características Fiscais e Especiais</h6>
                                <div class="row g-3 mb-3">
                                    <div class="col-sm-6">
                                        <span class="d-block small text-muted">EAN / Código de Barras</span>
                                        <span class="fw-medium">{{ selectedProductView.barcode || '-' }}</span>
                                    </div>
                                    <div class="col-sm-6">
                                        <span class="d-block small text-muted">Origem Fiscal</span>
                                        <span class="fw-medium">{{ selectedProductView.origin }} - Origem do
                                            Produto</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap gap-2 mb-3">
                                    <span v-if="selectedProductView?.is_perishable"
                                        class="badge bg-warning text-dark px-3 py-2 rounded-pill">Perecível</span>
                                    <span v-if="selectedProductView?.has_expiration"
                                        class="badge bg-warning text-dark px-3 py-2 rounded-pill">Possui
                                        vencimento</span>
                                    <span v-if="selectedProductView.is_fragile"
                                        class="badge bg-info text-dark px-3 py-2 rounded-pill">Frágil</span>
                                    <span v-if="selectedProductView.is_hazardous"
                                        class="badge bg-danger px-3 py-2 rounded-pill">Carga Perigosa</span>
                                    <span
                                        v-if="!selectedProductView.is_perishable && !selectedProductView.is_fragile && !selectedProductView.is_hazardous && !selectedProductView.has_expiration"
                                        class="text-muted small">Nenhuma restrição especial.</span>
                                </div>
                                <div>
                                    <span class="d-block small text-muted mb-1">Observações</span>
                                    <div class="p-3 bg-light rounded-3 small">
                                        {{ selectedProductView.observations || 'Nenhuma observação registrada.' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pt-0">
                        <button type="button" class="btn btn-pmg-light w-100" @click="closeViewModal"><i
                                class="bi bi-x"></i>
                            Fechar
                            Detalhes</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalProduct" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-0">
                        <h5 class="fw-bold m-0">{{ isEditing ? 'Editar Produto' : 'Novo Produto' }}</h5>
                        <button type="button" class="btn-close" @click="closeProductModal"></button>
                    </div>
                    <div class="modal-body p-4">

                        <ul class="nav nav-tabs pmg-tabs mb-4 border-0">
                            <li class="nav-item">
                                <button class="nav-link" :class="{ active: activeTab === 'basic' }"
                                    @click.prevent="activeTab = 'basic'">Informações Básicas</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link" :class="{ active: activeTab === 'logistics' }"
                                    @click.prevent="activeTab = 'logistics'">Logística e Armazenagem</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link" :class="{ active: activeTab === 'attributes' }"
                                    @click.prevent="activeTab = 'attributes'">Características</button>
                            </li>
                        </ul>

                        <div>
                            <div v-show="activeTab === 'basic'" class="row g-3">
                                <span class="text-danger small me-auto fw-medium" v-if="!isFormValid">
                                    <i class="bi bi-info-circle me-1"></i>
                                    <small>Preencha os campos obrigatórios (*).</small>
                                </span>
                                <div class="col-md-8">
                                    <label class="form-label small fw-bold text-muted">Nome do Produto <span
                                            class="text-danger">*</span></label>
                                    <input v-model="form.name" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: Computador All-in-One 24 polegadas">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label small fw-bold text-muted">SKU (Código) <span
                                            class="text-danger">*</span></label>
                                    <input v-model="form.sku" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: COMP-AIO-001">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label small fw-bold text-muted">Categoria</label>
                                    <div class="position-relative">
                                        <input v-model="categorySearch" @input="buscarCategorias"
                                            @blur="fecharDropdownCategoria" type="text"
                                            class="form-control form-control-pmg" placeholder="Pesquisar categoria...">
                                        <ul v-if="showCategoryDropdown"
                                            class="dropdown-menu show w-100 shadow-sm border-0 mt-1 scrollable-menu">
                                            <li v-if="categoryResults.length === 0"
                                                class="dropdown-item text-muted small">
                                                Nenhuma categoria encontrada</li>
                                            <li v-for="cat in categoryResults" :key="cat.id">
                                                <a class="dropdown-item py-2" href="#"
                                                    @mousedown.prevent="selecionarCategoria(cat)">{{ cat.name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label small fw-bold text-muted">Preço Custo (R$)</label>
                                    <div class="input-group">
                                        <span
                                            class="input-group-text bg-light border-end-0 text-muted fw-bold">R$</span>
                                        <input v-model="formattedCostPrice" type="text"
                                            class="form-control form-control-pmg border-start-0 ps-0"
                                            placeholder="0,00">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label small fw-bold text-muted">Preço Venda (R$)</label>
                                    <div class="input-group">
                                        <span
                                            class="input-group-text bg-light border-end-0 text-muted fw-bold">R$</span>
                                        <input v-model="formattedPrice" type="text"
                                            class="form-control form-control-pmg border-start-0 ps-0"
                                            placeholder="0,00">
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <label class="form-label small fw-bold text-muted">Estoque Mín.</label>
                                    <input v-model="form.min_stock" type="number" class="form-control form-control-pmg"
                                        placeholder="Ex: 5">
                                </div>

                                <div class="col-md-12 mt-4">
                                    <h6 class="fw-bold text-uppercase text-muted small mb-3 border-bottom pb-2">Vitrini
                                        e
                                        E-commerce</h6>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label small fw-bold text-muted">Descrição do Produto
                                        (Vitrini)</label>
                                    <textarea v-model="form.description" class="form-control form-control-pmg" rows="3"
                                        placeholder="Escreva o texto comercial que aparecerá em destaque..."></textarea>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label small fw-bold text-muted">Especificações Técnicas</label>
                                    <textarea v-model="form.technical_description" class="form-control form-control-pmg"
                                        rows="3" placeholder="Dimensões, peso, material, voltagem..."></textarea>
                                </div>
                                <div class="col-md-12 mt-3">
                                    <label class="form-label small fw-bold text-muted">Galeria de Fotos
                                        (Vitrini)</label>
                                    <div
                                        class="border d-flex flex-column align-items-center justify-content-center p-4 rounded-3 bg-light position-relative cursor-pointer border-dashed">
                                        <i class="bi bi-cloud-upload text-muted display-6 mb-2"></i>
                                        <span class="small fw-medium text-secondary">Clique para selecionar ou arraste
                                            as
                                            fotos</span>
                                        <span class="text-muted" style="font-size: 11px;">Formatos aceitos: JPG,
                                            PNG</span>
                                        <input type="file" @change="handleImageUpload" multiple accept="image/*"
                                            class="position-absolute w-100 h-100 top-0 start-0 opacity-0 cursor-pointer">
                                    </div>
                                    <div v-if="imagePreviews.length > 0" class="d-flex flex-wrap gap-2 mt-3">
                                        <div v-for="(img, idx) in imagePreviews" :key="idx"
                                            class="position-relative border rounded-3 overflow-hidden shadow-sm"
                                            style="width: 80px; height: 80px;">
                                            <img :src="img.url" class="w-100 h-100 object-fit-cover">
                                            <button type="button" @click="removeImage(idx)"
                                                class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0 d-flex align-items-center justify-content-center"
                                                style="width: 20px; height: 20px; font-size: 12px;">
                                                <i class="bi bi-x"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-show="activeTab === 'logistics'" class="row g-3">
                                <div class="col-md-4">
                                    <label class="form-label small fw-bold text-muted">Unidade de Medida</label>
                                    <select v-model="form.unit_of_measure" class="form-select form-control-pmg">
                                        <option value="UN">Unidade (UN)</option>
                                        <option value="KG">Quilograma (KG)</option>
                                        <option value="LT">Litro (LT)</option>
                                        <option value="CX">Caixa (CX)</option>
                                        <option value="MT">Metro (MT)</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label small fw-bold text-muted">Peso (kg)</label>
                                    <input v-model="form.weight" type="number" step="0.001"
                                        class="form-control form-control-pmg" placeholder="Ex: 1.500">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label small fw-bold text-muted">Dimensões (A x L x C)</label>
                                    <input v-model="form.dimensions" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: 20x15x30 cm">
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label class="form-label small fw-bold text-muted">Localização Física no
                                        Estoque</label>
                                    <input v-model="form.storage_location" type="text"
                                        class="form-control form-control-pmg"
                                        placeholder="Ex: Corredor B, Estante 4, Prateleira 2">
                                </div>
                            </div>

                            <div v-show="activeTab === 'attributes'" class="row g-3">
                                <div class="col-md-6">
                                    <label class="form-label small fw-bold text-muted">Código de Barras
                                        (EAN/GTIN)</label>
                                    <input v-model="form.barcode" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: 7891010101010">
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label small fw-bold text-muted">Origem Fiscal (ICMS)</label>
                                    <select v-model="form.origin" class="form-select form-control-pmg">
                                        <option value="0">0 - Nacional</option>
                                        <option value="1">1 - Estrangeira (Importação direta)</option>
                                        <option value="2">2 - Estrangeira (Mercado interno)</option>
                                        <option value="3">3 - Nacional (Conteúdo Imp. > 40%)</option>
                                        <option value="4">4 - Nacional (Processos produtivos)</option>
                                        <option value="5">5 - Nacional (Conteúdo Imp. &lt;= 40%)</option>
                                        <option value="6">6 - Estrangeira (Imp. direta, sem similar)</option>
                                        <option value="7">7 - Estrangeira (Merc. interno, sem similar)</option>
                                        <option value="8">8 - Nacional (Conteúdo Imp. > 70%)</option>
                                    </select>
                                </div>
                                <div class="col-12 mt-4">
                                    <div class="d-flex flex-wrap gap-4 p-3 bg-light rounded-3">
                                        <div class="form-check pmg-switch">
                                            <input class="form-check-input" type="checkbox" v-model="form.is_perishable"
                                                id="chkPerishable">
                                            <label class="form-check-label fw-bold text-muted small"
                                                for="chkPerishable">Produto
                                                Perecível</label>
                                        </div>
                                        <div class="form-check pmg-switch">
                                            <input class="form-check-input" type="checkbox" v-model="form.is_fragile"
                                                id="chkFragile">
                                            <label class="form-check-label fw-bold text-muted small"
                                                for="chkFragile">Produto
                                                Frágil</label>
                                        </div>
                                        <div class="form-check pmg-switch">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="form.has_expiration" id="chkExpiration">
                                            <label class="form-check-label fw-bold text-muted small"
                                                for="chkExpiration">Produto
                                                com vencimento</label>
                                        </div>
                                        <div class="form-check pmg-switch">
                                            <input class="form-check-input" type="checkbox" v-model="form.is_hazardous"
                                                id="chkHazardous">
                                            <label class="form-check-label fw-bold text-danger small"
                                                for="chkHazardous">Carga
                                                Perigosa</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <label class="form-label small fw-bold text-muted">Observações Internas</label>
                                    <textarea v-model="form.observations" class="form-control form-control-pmg" rows="3"
                                        placeholder="Insira informações sobre manuseio, validade ou detalhes técnicos..."></textarea>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end gap-2 mt-5">

                                <button type="button" class="btn btn-pmg-light px-4"
                                    @click="closeProductModal">Cancelar</button>
                                <button type="button" class="btn btn-pmg-primary px-5" @click="saveProduct">Salvar
                                    Alterações</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalStockMovement" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-3 px-4 pb-0">
                        <h5 class="fw-bold m-0 text-dark">Operação de Estoque</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body p-3 px-4">
                        <div class="d-flex align-items-center mb-3 p-2 bg-light rounded-3 border">
                            <div class="me-3">
                                <div class="bg-white p-2 rounded shadow-sm border"><i
                                        class="bi bi-box-seam fs-4 text-primary"></i></div>
                            </div>
                            <div>
                                <h6 class="fw-bold mb-0 text-dark" style="font-size: 0.9rem;">{{
                                    selectedProductStock?.name }}
                                </h6>
                                <span class="text-muted" style="font-size: 0.75rem;">SKU: {{ selectedProductStock?.sku
                                    }}</span>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Saldos
                                Disponíveis</label>
                            <div class="border rounded-3 overflow-hidden bg-white">
                                <div v-for="branch in selectedProductStock?.branches" :key="branch.id"
                                    class="d-flex justify-content-between align-items-center p-2 px-3 border-bottom last-child-no-border">
                                    <span class="small text-dark"><i class="bi bi-building me-2 text-muted"></i>{{
                                        branch.name
                                        }}</span>
                                    <span class="text-primary fw-bold">
                                        {{ branch.pivot.stock }} <small class="text-muted fw-normal">{{
                                            selectedProductStock?.unit_of_measure }}</small>
                                    </span>
                                </div>
                                <div v-if="!selectedProductStock?.branches?.length"
                                    class="small text-muted text-center py-2">
                                    Nenhum saldo registrado.
                                </div>
                            </div>
                        </div>

                        <div class="row g-2">
                            <div class="col-12">
                                <label class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Tipo de
                                    Operação</label>
                                <select v-model="movementForm.type" class="form-select form-control-pmg py-2">
                                    <option value="INPUT">Entrada Manual</option>
                                    <option value="OUTPUT">Saída / Baixa Manual</option>
                                    <option value="TRANSFER">Transferência entre Filiais</option>
                                </select>
                            </div>

                            <template v-if="movementForm.type !== 'TRANSFER'">
                                <div class="col-md-7">
                                    <label
                                        class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Filial</label>
                                    <select v-model="movementForm.branch_id" class="form-select form-control-pmg py-2">
                                        <option value="" disabled>Selecione...</option>
                                        <option v-for="b in branches" :key="b.id" :value="b.id">{{ b.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-5">
                                    <label
                                        class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Qtd.</label>
                                    <input v-model="movementForm.quantity" type="number" step="0.01"
                                        class="form-control form-control-pmg py-2">
                                </div>
                            </template>

                            <template v-if="movementForm.type === 'TRANSFER'">
                                <div class="col-md-6">
                                    <label class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Filial
                                        Origem</label>
                                    <select v-model="movementForm.origin_branch_id"
                                        class="form-select form-control-pmg py-2">
                                        <option value="" disabled>Selecione...</option>
                                        <option v-for="b in branches" :key="b.id" :value="b.id">{{ b.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Filial
                                        Destino</label>
                                    <select v-model="movementForm.destination_branch_id"
                                        class="form-select form-control-pmg py-2">
                                        <option value="" disabled>Selecione...</option>
                                        <option v-for="b in branches" :key="b.id" :value="b.id">{{ b.name }}</option>
                                    </select>
                                </div>
                                <div class="col-12 mt-2">
                                    <label
                                        class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Quantidade
                                        a Transferir</label>
                                    <input v-model="movementForm.quantity" type="number" step="0.01"
                                        class="form-control form-control-pmg py-2" placeholder="0.00">
                                </div>
                            </template>

                            <template
                                v-if="(selectedProductStock?.is_perishable || selectedProductStock?.has_expiration) && movementForm.type !== 'TRANSFER'">
                                <div v-if="movementForm.type === 'INPUT'" class="col-12 mt-2">
                                    <div class="p-2 px-3 bg-warning-subtle border border-warning-subtle rounded-4">
                                        <div class="d-flex align-items-center mb-2">
                                            <i class="bi bi-calendar-check text-warning me-2"></i>
                                            <span class="ultra-small fw-bold text-dark text-uppercase">Controle de Lote
                                                e Validade</span>
                                        </div>
                                        <div class="row g-2">
                                            <div class="col-md-4">
                                                <label
                                                    class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Nº
                                                    do Lote *</label>
                                                <input v-model="movementForm.batch_number" type="text"
                                                    class="form-control form-control-sm" placeholder="Ex: 0001">
                                            </div>
                                            <div class="col-md-4">
                                                <label
                                                    class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Fabricação</label>
                                                <input v-model="movementForm.manufacturing_date" type="date"
                                                    class="form-control form-control-sm">
                                            </div>
                                            <div class="col-md-4">
                                                <label
                                                    class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Validade
                                                    *</label>
                                                <input v-model="movementForm.expiration_date" type="date"
                                                    class="form-control form-control-sm">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else-if="movementForm.type === 'OUTPUT'" class="col-12 mt-2">
                                    <div
                                        class="alert alert-info py-2 px-3 mb-0 border-0 small d-flex align-items-center rounded-3">
                                        <i class="bi bi-info-circle-fill fs-5 me-2 text-info"></i>
                                        <span><strong>Saída Inteligente (FEFO):</strong> O sistema baixará o estoque do
                                            lote com o vencimento mais próximo.</span>
                                    </div>
                                </div>
                            </template>

                            <div class="col-12 mt-2">
                                <label class="form-label ultra-small fw-bold text-muted text-uppercase mb-1">Motivo /
                                    Justificativa</label>
                                <textarea v-model="movementForm.reason" class="form-control form-control-pmg" rows="2"
                                    placeholder="Ex: Ajuste por quebra..."></textarea>
                            </div>
                        </div>

                        <div class="mt-3">
                            <button class="btn btn-pmg-primary w-100 py-2 fw-bold" @click="executeMovement"
                                :disabled="!isMovementValid">
                                <i class="bi bi-check-circle me-2"></i> Confirmar Operação
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalAuditTimeline" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <div>
                        <h5 class="fw-bold m-0 text-dark">Trilha de Auditoria</h5>
                        <p class="text-muted small mb-0" v-if="selectedProductAudit">
                            Item: <strong>{{ selectedProductAudit.name }}</strong>
                        </p>
                    </div>
                    <button type="button" class="btn-close" @click="closeAuditModal"></button>
                </div>
                <div class="modal-body p-4">
                    <div class="audit-scroll-container">
                        <div v-if="auditLogs.length > 0" class="timeline">
                            <div v-for="log in auditLogs" :key="log.id" class="timeline-item pb-4">
                                <div class="timeline-marker"></div>

                                <div class="ms-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="fw-bold text-dark small">
                                            <i class="bi bi-person-circle me-1"></i> {{ log.user?.name || 'Sistema' }}
                                        </span>
                                        <span class="text-muted" style="font-size: 0.7rem;">
                                            {{ formatarDataBR(log.created_at) }}
                                        </span>
                                    </div>

                                    <span class="badge mb-2 mt-1"
                                        :class="log.action === 'updated' ? 'bg-primary-subtle text-primary' : 'bg-success-subtle text-success'"
                                        style="font-size: 0.6rem; text-transform: uppercase;">
                                        {{ log.action === 'updated' ? 'Edição' : 'Criação' }}
                                    </span>

                                    <div class="bg-light p-2 rounded-3 border-start border-3 border-primary shadow-sm">
                                        <div v-for="(newValue, field) in log.new_values" :key="field"
                                            class="mb-2 border-bottom border-white pb-1 last-child-no-border">
                                            <span class="d-block small text-muted text-uppercase fw-bold"
                                                style="font-size: 0.55rem;">
                                                Campo: {{ translateField(field) }}
                                            </span>
                                            <div class="d-flex align-items-center gap-2 small">
                                                <span class="text-danger text-decoration-line-through">
                                                    {{ formatValue(field, log.old_values ? log.old_values[field] : null)
                                                    }}
                                                </span>
                                                <i class="bi bi-arrow-right text-muted"></i>
                                                <span class="text-success fw-bold">
                                                    {{ formatValue(field, newValue) }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center py-5">
                            <i class="bi bi-journal-x fs-1 text-muted opacity-25"></i>
                            <p class="text-muted mt-3">Nenhum histórico encontrado para este item.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalGeneralReport" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <h5 class="fw-bold m-0 text-dark">Filtros do Relatório Geral</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body p-4">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Data Inicial</label>
                            <input type="date" v-model="reportFilter.start_date" class="form-control form-control-pmg">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Data Final</label>
                            <input type="date" v-model="reportFilter.end_date" class="form-control form-control-pmg">
                        </div>

                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Categoria</label>
                            <select v-model="reportFilter.category_id" class="form-select form-control-pmg">
                                <option value="">Todas as Categorias</option>
                                <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                            </select>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Tipo de Movimentação</label>
                            <select v-model="reportFilter.type" class="form-select form-control-pmg">
                                <option value="ALL">Todas (Entradas e Saídas)</option>
                                <option value="INPUT">Apenas Entradas</option>
                                <option value="OUTPUT">Apenas Saídas</option>
                            </select>
                        </div>

                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Perecíveis</label>
                            <select v-model="reportFilter.is_perishable" class="form-select form-control-pmg">
                                <option value="ALL">Indiferente</option>
                                <option value="YES">Apenas Perecíveis</option>
                                <option value="NO">Apenas Não Perecíveis</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Controle de validade?</label>
                            <select v-model="filter.has_expiration" class="form-select form-control-pmg">
                                <option value="ALL">Todos</option>
                                <option value="YES">Sim</option>
                                <option value="NO">Não</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Carga Perigosa</label>
                            <select v-model="reportFilter.is_hazardous" class="form-select form-control-pmg">
                                <option value="ALL">Indiferente</option>
                                <option value="YES">Apenas Perigosos</option>
                                <option value="NO">Apenas Não Perigosos</option>
                            </select>
                        </div>
                    </div>

                    <div class="mt-5">
                        <button class="btn btn-pmg-primary w-100 py-3 fw-bold"
                            @click="exportFormat === 'pdf' ? downloadGeneralReport() : exportClientsExcel()">
                            <template v-if="loadingReport">
                                <span class="spinner-border spinner-border-sm me-2"></span>
                                PROCESSANDO...
                            </template>
                            <template v-else>
                                <i :class="exportFormat === 'pdf' ? 'bi-file-earmark-pdf-fill' : 'bi-file-earmark-excel-fill'"
                                    class="me-2"></i>
                                {{ exportFormat === 'pdf' ? 'GERAR RELATÓRIO PDF' : 'EXPORTAR PLANILHA XLSX' }}
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                <div class="modal-body">
                    <div class="text-danger mb-3">
                        <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                    </div>
                    <h5 class="fw-bold">Tem certeza?</h5>
                    <p class="text-muted small">{{ isBulkDelete ? `Excluir ${selectedIds.length} produto(s)
                        selecionado(s)?` : `Excluir "${itemToDelete?.nome || itemToDelete?.name}"?` }}</p>
                </div>
                <div class="d-flex gap-2 justify-content-center pb-2">
                    <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalMovementHistory" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <div>
                        <h5 class="fw-bold m-0 text-dark">Extrato de Movimentações</h5>
                        <p class="text-muted small mb-0">Produto: <strong>{{ selectedProductHistory?.name }}</strong>
                        </p>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body p-4">
                    <div class="row g-3 mb-4 p-3 bg-light rounded-4 shadow-sm border-0 align-items-end">
                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Data Inicial (Mov.)</label>
                            <input v-model="historyFilter.start_date" type="date"
                                class="form-control form-control-pmg py-2">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Data Final (Mov.)</label>
                            <input v-model="historyFilter.end_date" type="date"
                                class="form-control form-control-pmg py-2">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Tipo de Operação</label>
                            <select v-model="historyFilter.type" class="form-select form-control-pmg py-2">
                                <option value="ALL">Todos os Tipos</option>
                                <option value="INPUT">Entradas</option>
                                <option value="OUTPUT">Saídas</option>
                                <option value="TRANSFER">Transferências</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-pmg-light w-100 py-2 border shadow-sm" @click="clearHistoryFilters">
                                <i class="bi bi-arrow-counterclockwise me-1"></i> Limpar
                            </button>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Vencimento (De)</label>
                            <input v-model="historyFilter.exp_start" type="date"
                                class="form-control form-control-pmg py-2">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small fw-bold text-muted">Vencimento (Até)</label>
                            <input v-model="historyFilter.exp_end" type="date"
                                class="form-control form-control-pmg py-2">
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-pmg-primary w-100 py-2 shadow-sm" @click="fetchMovementHistory">
                                <i class="bi bi-search me-2"></i> Aplicar Filtros Avançados
                            </button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-end mb-2 px-1">
                        <span class="text-muted small fw-bold">
                            <i class="bi bi-card-list me-1"></i> Resultados da busca
                        </span>
                        <div class="d-flex gap-2">
                            <button class="btn btn-pmg-light btn-sm px-3 shadow-sm rounded-3 fw-bold"
                                @click="exportHistory('pdf')" title="Exportar para PDF">
                                <i class="bi bi-file-earmark-pdf-fill me-1 text-danger"></i> PDF
                            </button>
                            <button class="btn btn-pmg-light btn-sm px-3 shadow-sm rounded-3 fw-bold"
                                @click="exportHistory('excel')" title="Exportar para Excel">
                                <i class="bi bi-file-earmark-excel-fill me-1 text-success"></i> Excel
                            </button>
                        </div>
                    </div>
                    <div class="table-responsive" style="max-height: 400px;">
                        <table class="table table-hover align-middle">
                            <thead class="table-light sticky-top">
                                <tr>
                                    <th class="small fw-bold">DATA/HORA</th>
                                    <th class="small fw-bold">FILIAL</th>
                                    <th class="small fw-bold">OPERAÇÃO</th>
                                    <th class="small fw-bold">QUANTIDADE</th>
                                    <th class="small fw-bold">LOTE / VALIDADE</th>
                                    <th class="small fw-bold">MOTIVO</th>
                                    <th class="small fw-bold">USUÁRIO</th>
                                </tr>
                            </thead>
                            <tbody v-if="historyMovements.length > 0">
                                <tr v-for="log in historyMovements" :key="log.id">
                                    <td class="small text-muted">{{ formatarDataBR(log.created_at) }}</td>
                                    <td class="small">
                                        <div v-if="log.type === 'TRANSFER'" class="d-flex align-items-center">
                                            <span class="fw-bold text-secondary">{{ log.branch?.name }}</span>
                                            <i class="bi bi-arrow-right mx-2 text-primary"></i>
                                            <span class="fw-bold text-dark">{{ log.destination_branch?.name }}</span>
                                        </div>

                                        <span v-else>{{ log.branch?.name }}</span>
                                    </td>
                                    <td>
                                        <span class="badge rounded-pill px-2 py-1"
                                            :class="log.type === 'INPUT' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
                                            {{ log.type === 'INPUT' ? 'Entrada' : 'Saída' }}
                                        </span>
                                    </td>
                                    <td class="fw-bold">{{ log.quantity }}</td>
                                    <td class="small">
                                        <div v-if="log.batch" class="d-flex flex-column">
                                            <span class="badge bg-warning-subtle text-warning-emphasis border">
                                                <i class="bi bi-tag-fill me-1 text-warning"></i>{{
                                                    log.batch.batch_number }}
                                            </span>
                                            <span class="text-muted mt-1" style="font-size: 0.7rem;">
                                                Vence: {{ formatDate(log.batch.expiration_date) }}
                                            </span>
                                        </div>
                                        <span v-else class="text-muted">-</span>
                                    </td>
                                    <td class="small text-truncate" style="max-width: 200px;" :title="log.reason">
                                        {{ log.reason || '-' }}
                                    </td>
                                    <td class="small"><i class="bi bi-person me-1"></i>{{ log.user?.name || 'Sistema' }}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="7" class="text-center py-5 text-muted">
                                        <i class="bi bi-info-circle me-2"></i>Nenhuma movimentação encontrada para este
                                        período.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer border-0">
                    <button class="btn btn-pmg-light w-100" data-bs-dismiss="modal">Fechar Extrato</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalImportPreview" tabindex="-1" aria-hidden="true" ref="modalImportPreview">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4">
                    <h5 class="fw-bold m-0">
                        <i class="bi bi-file-earmark-arrow-up me-2 text-primary"></i>Pré-visualização da Importação
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" @click="resetImport"></button>
                </div>

                <div class="modal-body p-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="text-muted small">Siga o padrão das colunas para evitar erros na importação de
                            produtos.</span>
                        <a href="#" @click.prevent="downloadImportTemplate"
                            class="btn btn-link btn-sm p-0 text-decoration-none">
                            <i class="bi bi-download me-1"></i> Baixar Planilha Exemplo
                        </a>
                    </div>

                    <div v-if="importDuplicates.length > 0" class="alert alert-danger border-0 shadow-sm mb-3">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-layers-half fs-4 me-3"></i>
                            <div>
                                <h6 class="fw-bold mb-1">SKU ou Código de Barras Duplicado</h6>
                                <p class="small mb-0">
                                    Encontramos registros com o mesmo SKU/Código nas linhas:
                                    <strong>{{importDuplicates.map(d => d.linha).join(', ')}}</strong>.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="importErrors.length > 0" class="alert alert-warning border-0 shadow-sm mb-3">
                        <div class="d-flex">
                            <i class="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                            <div>
                                <h6 class="fw-bold mb-1">Atenção: {{ importErrors.length }} linha(s) com dados
                                    incompletos
                                </h6>
                                <p class="small mb-0 text-secondary">
                                    Faltam informações obrigatórias (Nome, SKU ou Preço) nas linhas:
                                    <strong>{{importErrors.map(e => e.linha).join(', ')}}</strong>.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="!importPreviewData.length"
                        class="upload-area p-5 border-2 border-dashed rounded text-center bg-light">
                        <input type="file" ref="fileInputImport" @change="handleFilePreview" class="d-none"
                            accept=".xlsx,.csv">
                        <i class="bi bi-box-seam fs-1 text-muted opacity-50"></i>
                        <p class="mt-3 mb-4">Selecione a planilha de catálogo de produtos para análise</p>
                        <button class="btn btn-pmg-primary" @click="$refs.fileInputImport.click()">
                            Escolher Arquivo
                        </button>
                    </div>

                    <div v-else>
                        <div class="alert alert-info border-0 rounded-3 small">
                            <i class="bi bi-info-circle me-2"></i>
                            Encontramos <strong>{{ importPreviewData.length }}</strong> produtos. Verifique as colunas
                            antes
                            de confirmar.
                        </div>

                        <div class="table-responsive rounded-3 border">
                            <table class="table table-sm table-hover mb-0" style="min-width: 1000px;">
                                <thead class="bg-light">
                                    <tr>
                                        <th class="small text-muted py-2 ps-3" style="width: 50px;">#</th>
                                        <th class="small text-muted py-2" style="width: 120px;">SKU</th>
                                        <th class="small text-muted py-2" style="width: 250px;">PRODUTO</th>
                                        <th class="small text-muted py-2">CATEGORIA</th>
                                        <th class="small text-muted py-2 text-center" style="width: 100px;">ESTOQUE</th>
                                        <th class="small text-muted py-2 text-center" style="width: 80px;">UNID.</th>
                                        <th class="small text-muted py-2 text-end" style="width: 120px;">PREÇO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in importPreviewData" :key="index"
                                        :class="{ 'table-danger-light': row.isInvalid }">
                                        <td class="ps-3 small text-muted">{{ row.excelRow }}</td>
                                        <td class="small fw-bold">
                                            <i v-if="row.isInvalid || row.isDuplicate"
                                                class="bi bi-exclamation-circle-fill text-danger me-1"
                                                :title="row.errorsList"></i>
                                            {{ row.sku }}
                                        </td>
                                        <td class="small">
                                            <div class="text-truncate" style="max-width: 230px;" :title="row.nome">{{
                                                row.nome }}</div>
                                        </td>
                                        <td class="small text-muted">{{ row.categoria }}</td>
                                        <td class="small text-center fw-bold">{{ row.estoque }}</td>
                                        <td class="small text-center">{{ row.unidade }}</td>
                                        <td class="small text-end fw-bold text-success">R$ {{ row.preco }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="modal-footer border-0 p-4 pt-0">
                    <button class="btn btn-pmg-light" data-bs-dismiss="modal" @click="resetImport">Cancelar</button>
                    <button class="btn btn-pmg-primary px-4" :disabled="!importPreviewData.length || loadingImport"
                        @click="executeFinalImport">
                        <span v-if="loadingImport" class="spinner-border spinner-border-sm me-2"></span>
                        Confirmar e Importar Produtos
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';
import * as XLSX from 'xlsx';

export default {
    name: 'ProdutoList',
    inject: ['globalLoading'],
    data() {
        return {
            products: [], alerts: [], showFilter: false, loading: false,
            activeTab: 'basic', isEditing: false, form: this.getInitialForm(),
            selectedProductView: null,
            imagePreviews: [], // Armazena visualizações base64 para vitrine
            categorySearch: '', categoryResults: [], showCategoryDropdown: false, searchTimeout: null,
            stockTab: 'form', selectedProductStock: null, stockHistory: [],
            stockForm: { product_id: '', type: 'INPUT', quantity: null, reason: '', observations: '' },
            auditLogs: [],
            selectedProductAudit: null,
            selectedIds: [],
            filter: {
                search: '',
                category_id: '',
                is_perishable: 'ALL',
                has_expiration: 'ALL',
                is_hazardous: 'ALL'
            },
            reportFilter: {
                start_date: '',
                end_date: '',
                type: 'ALL',
                category_id: '',
                is_perishable: 'ALL',
                has_expiration: 'ALL',
                is_hazardous: 'ALL'
            },
            modalInstance: null,
            itemToDelete: null,
            isBulkDelete: false,
            branches: [],
            movementForm: {
                type: 'INPUT',
                branch_id: '',
                origin_branch_id: '',
                destination_branch_id: '',
                quantity: '',
                reason: '',
                batch_number: '',
                manufacturing_date: '',
                expiration_date: ''
            },
            selectedProductHistory: null,
            historyMovements: [],
            historyFilter: {
                start_date: '',
                end_date: '',
                type: 'ALL',
                near_expiration: 'NO',
                exp_start: '',
                exp_end: ''
            },
            exportFormat: 'pdf',
            importPreviewData: [],
            importFileObject: null,
            modalImportInstance: null,
            importErrors: [],
            importDuplicates: [],
            loadingImport: false,
        }
    },
    computed: {
        formattedCostPrice: {
            get() {
                let val = parseFloat(this.form.cost_price) || 0;
                return val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            set(value) {
                let numbers = value.toString().replace(/\D/g, '');
                this.form.cost_price = numbers ? parseFloat(numbers) / 100 : 0;
            },
        },
        formattedPrice: {
            get() {
                let val = parseFloat(this.form.price) || 0;
                return val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            set(value) {
                let numbers = value.toString().replace(/\D/g, '');
                this.form.price = numbers ? parseFloat(numbers) / 100 : 0;
            },
        },
        isMovementValid() {
            if (!this.movementForm.quantity || this.movementForm.quantity <= 0) return false;
            if (!this.movementForm.reason?.trim()) return false;

            if (this.movementForm.type === 'TRANSFER') {
                return this.movementForm.origin_branch_id &&
                    this.movementForm.destination_branch_id &&
                    this.movementForm.origin_branch_id !== this.movementForm.destination_branch_id;
            }

            if (!this.movementForm.branch_id) return false;

            const requiresBatch = this.selectedProductStock?.is_perishable || this.selectedProductStock?.has_expiration;

            if (requiresBatch && this.movementForm.type === 'INPUT') {
                if (!this.movementForm.batch_number?.trim() || !this.movementForm.expiration_date) {
                    return false;
                }
            }

            return true;
        },
        isFormValid() {
            return this.form.name && this.form.sku;
        },
        isAllSelected() { return this.products.length > 0 && this.products.every(i => this.selectedIds.includes(i.id)); },
    },
    mounted() { this.fetchProducts(); this.fetchCategoriesForReport(); this.fetchBranches(); },
    methods: {
        async fetchBranches() {
            try {
                const res = await api.get('/branches');
                this.branches = res.data.data || res.data;
            } catch (error) {
                console.error("Erro ao carregar filiais", error);
            }
        },
        async fetchCategoriesForReport() {
            const res = await api.get('/categories');
            this.categories = res.data.data || res.data;
        },
        getInitialForm() {
            return {
                id: null, name: '', sku: '', category_id: '',
                cost_price: 0, price: 0, min_stock: 5,
                unit_of_measure: 'UN', weight: '', dimensions: '', storage_location: '',
                barcode: '', origin: '0', is_perishable: false, is_fragile: false, has_expiration: false, is_hazardous: false,
                description: '', technical_description: '', images: [], observations: ''
            };
        },

        handleImageUpload(event) {
            const files = Array.from(event.target.files);

            files.forEach(file => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreviews.push({ url: e.target.result, isNew: true });
                    this.form.images.push(file);
                };
                reader.readAsDataURL(file);
            });
            event.target.value = ''; // Reseta para permitir reenviar
        },
        removeImage(index) {
            this.imagePreviews.splice(index, 1);
            this.form.images.splice(index, 1);
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/products/bulk-delete', {
                        ids: this.selectedIds
                    });
                    this.products = this.products.filter(c => !this.selectedIds.includes(c.id));
                    this.totalItems -= this.selectedIds.length;
                    this.showAlert(`${this.selectedIds.length} Produtos excluídos.`);
                    this.selectedIds = [];
                } else {
                    await api.delete(`/products/${this.itemToDelete.id}`);
                    this.products = this.products.filter(c => c.id !== this.itemToDelete.id);
                    this.totalItems -= 1;
                    const itemName = this.itemToDelete.nome || this.itemToDelete.name;
                    this.showAlert(`Produto "${itemName}" removido.`);
                }

            } catch (error) {
                console.error("Erro ao excluir registro(s):", error);
                const errorMessage = error.response?.data?.message || 'Erro ao comunicar com o servidor para excluir.';
                this.showAlert(errorMessage, 'error');

            } finally {
                const modalElement = document.getElementById('confirmDeleteModal');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
            }
        },
        toggleAll(e) {
            if (e.target.checked) this.selectedIds = this.products.map(c => c.id);
            else this.selectedIds = [];
        },

        openModal(mode, item = null) {
            this.activeTab = 'basic';
            this.isEditing = (mode === 'edit');

            if (this.isEditing) {
                this.form = { ...item };
                console.log(this.form);
                this.form.images = item.images || []; // Garante array

                // Mapeia imagens já salvas no banco para visualização
                this.imagePreviews = this.form.images.map(img => ({ url: img, isNew: false }));
                this.categorySearch = item.category ? item.category.name : '';
            } else {
                this.form = this.getInitialForm();
                this.categorySearch = '';
                this.imagePreviews = [];
            }
            const el = document.getElementById('modalProduct');
            window.bootstrap.Modal.getOrCreateInstance(el).show();
        },
        closeProductModal() { window.bootstrap.Modal.getOrCreateInstance(document.getElementById('modalProduct')).hide(); },

        openViewModal(item) {
            this.selectedProductView = item;
            const el = document.getElementById('modalViewProduct');
            window.bootstrap.Modal.getOrCreateInstance(el).show();
        },
        closeViewModal() { window.bootstrap.Modal.getOrCreateInstance(document.getElementById('modalViewProduct')).hide(); },

        openStockModal(product) {
            this.selectedProductStock = product;
            this.movementForm = {
                type: 'INPUT',
                branch_id: '',
                origin_branch_id: '',
                destination_branch_id: '',
                quantity: '',
                reason: '',
                batch_number: '',
                manufacturing_date: '',
                expiration_date: ''
            };
            window.bootstrap.Modal.getOrCreateInstance(document.getElementById('modalStockMovement')).show();
        },
        closeStockModal() { window.bootstrap.Modal.getOrCreateInstance(document.getElementById('modalStockMovement')).hide(); },

        async fetchProducts(page = 1, append = false) {
            this.globalLoading.show('Carregando produtos...');
            this.loading = true;
            try {
                const params = {
                    page,
                    search: this.filter.search,
                    category_id: this.filter.category_id,
                    is_perishable: this.filter.is_perishable === 'ALL' ? null : (this.filter.is_perishable === 'YES' ? 1 : 0),
                    is_hazardous: this.filter.is_hazardous === 'ALL' ? null : (this.filter.is_hazardous === 'YES' ? 1 : 0),
                };

                const res = await api.get('/products', { params });
                const items = res.data.data || [];
                const meta = res.data.meta || res.data;

                if (append) this.products = [...this.products, ...items];
                else this.products = items;

                this.currentPage = meta.current_page || 1;
                this.lastPage = meta.last_page || 1;
                this.totalItems = meta.total || items.length;
                this.hasMore = this.currentPage < this.lastPage;
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        applyFilter() {
            this.selectedIds = [];
            this.fetchProducts(1, false);
        },

        loadMore() { if (this.hasMore) this.fetchProducts(this.currentPage + 1, true); },

        clearFilters() {
            this.filter = { search: '', category_id: '', is_perishable: 'ALL', is_hazardous: 'ALL', has_expiration: 'ALL' };
            this.applyFilter();
        },

        async saveProduct() {
            if (!this.form.name || !this.form.sku) {
                this.showAlert("Por favor, preencha o Nome e o SKU do produto.", "danger");
                this.activeTab = 'basic';
                return;
            }

            this.globalLoading.show('Salvando dados...');

            try {
                // Utilizando FormData para envio limpo de arquivos/imagens
                const formData = new FormData();

                Object.keys(this.form).forEach(key => {
                    if (key === 'images') {
                        if (this.form.images.length === 0) {
                            // Se o array está vazio, enviamos esta flag para o Laravel saber
                            formData.append('images_cleared', '1');
                        } else {
                            this.form.images.forEach((img, idx) => {
                                if (img instanceof File) {
                                    formData.append(`images[${idx}]`, img);
                                } else {
                                    formData.append(`images[${idx}]`, img);
                                }
                            });
                        }

                    } else if (this.form[key] !== null && this.form[key] !== undefined) {
                        let val = typeof this.form[key] === 'boolean' ? (this.form[key] ? 1 : 0) : this.form[key];
                        formData.append(key, val);
                    }
                });

                if (this.isEditing) {
                    formData.append('_method', 'PUT'); // Fake PUT para Laravel
                    await api.post(`/products/${this.form.id}`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                } else {
                    await api.post('/products', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                }

                this.closeProductModal();
                this.fetchProducts();
                this.showAlert("Produto salvo com sucesso!");
            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar.", "error");
                }
            } finally {
                this.globalLoading.hide();
            }
        },

        async saveStockMovement() {
            this.globalLoading.show('Gravando movimento...');
            try {
                await api.post('/stock-movements', this.stockForm);
                this.closeStockModal();
                this.fetchProducts();
                this.showAlert("Estoque atualizado!");
            } catch (e) {
                if (e.response?.status === 422) {

                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar.", "error");
                }
            } finally { this.globalLoading.hide(); }
        },
        async fetchStockHistory(productId) {
            try {
                const res = await api.get(`/stock-movements/${productId}`);
                this.stockHistory = res.data.data || res.data;
            } catch (e) { console.error(e); }
        },

        buscarCategorias() {
            if (this.categorySearch.length < 2) {
                this.showCategoryDropdown = false;
                return;
            }
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(async () => {
                try {
                    const res = await api.get(`/categories?search=${this.categorySearch}`);
                    this.categoryResults = res.data.data || res.data;
                    this.showCategoryDropdown = true;
                } catch (e) { console.error(e); }
            }, 300);
        },
        selecionarCategoria(cat) {
            this.form.category_id = cat.id;
            this.categorySearch = cat.name;
            this.showCategoryDropdown = false;
        },
        fecharDropdownCategoria() { setTimeout(() => { this.showCategoryDropdown = false; }, 200); },

        formatCurrency(v) { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v); },
        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = type === 'danger' ? 'bi-exclamation-circle-fill' : (type === 'error' ? 'bi-x-circle-fill' : 'bi-check-circle-fill');
            this.alerts.push({ id, message, type, icon });
            setTimeout(() => this.removeAlert(id), 8000);
        },
        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },

        async exportStockPdf(productId) {
            this.globalLoading.show('Gerando PDF...');
            try {
                // Usamos window.open ou uma requisição de blob para baixar o arquivo
                const response = await api.get(`/products/${productId}/stock-movements/export`, {
                    responseType: 'blob' // Importante para arquivos
                });

                // Cria um link temporário para o download
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `historico_estoque_${productId}.pdf`);
                document.body.appendChild(link);
                link.click();

                this.showAlert("PDF gerado com sucesso!");
            } catch (error) {
                this.showAlert("Erro ao gerar PDF", "danger");
            } finally {
                this.globalLoading.hide();
            }
        },

        async openAuditModal(product) {
            // 1. Verificação defensiva: Se o produto ou o ID forem nulos, não faz nada
            if (!product || !product.id) {
                this.showAlert("Erro: O produto ainda não possui um identificador válido.", "danger");
                return;
            }

            this.selectedProductAudit = product;
            this.auditLogs = []; // Limpa logs anteriores

            const el = document.getElementById('modalAuditTimeline');
            const modalInstance = window.bootstrap.Modal.getOrCreateInstance(el);
            modalInstance.show();

            this.globalLoading.show('Carregando trilha...');
            try {
                const res = await api.get(`/products/${product.id}/audit`);
                this.auditLogs = res.data;
            } catch (e) {
                console.error("Erro na auditoria:", e);
                this.showAlert("Não foi possível carregar o histórico.", "danger");
            } finally {
                this.globalLoading.hide();
            }
        },

        closeAuditModal() {
            window.bootstrap.Modal.getOrCreateInstance(document.getElementById('modalAuditTimeline')).hide();
        },

        // Traduz o nome da coluna do banco para algo amigável
        translateField(field) {
            const labels = {
                name: 'Nome',
                sku: 'SKU',
                price: 'Preço',
                cost_price: 'Preço de Custo',
                description: 'Descrição (Vitrini)',
                technical_description: 'Descrição Técnica',
                stock: 'Estoque',
                origin: 'Origem Fiscal',
                storage_location: 'Localização',
                is_hazardous: 'Perigoso',
                observations: 'Observações',
                unit_of_measure: 'Unidade de medida',
                is_fragile: 'É Fráfil?',
                dimensions: 'Dimensões',
                updated_at: 'Alterado em',
                min_stock: 'Estoque mínimo',
                weight: 'Peso',
                barcode: 'Código de barras',
                created_at: 'Criado em'
            };
            return labels[field] || field;
        },

        // Formata o valor dependendo do campo (ex: se for preço, põe R$)
        formatValue(field, value) {
            if (value === null || value === undefined) return 'Nulo';
            if (field === 'price' || field === 'cost_price') return this.formatCurrency(value);
            if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
            return value;
        },

        formatarDataBR(data) {
            return new Date(data).toLocaleString('pt-BR');
        },
        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteModal'));
            modal.show();
        },
        openReportModal(format = 'pdf') {
            this.exportFormat = format;
            if (this.reportModalInstance) {
                this.reportModalInstance.show();
            } else {
                const reportEl = document.getElementById('modalGeneralReport');
                if (reportEl) {
                    this.reportModalInstance = new window.bootstrap.Modal(reportEl);
                    this.reportModalInstance.show();
                }
            }
        },
        async downloadGeneralReport() {
            this.globalLoading.show('Gerando relatório...');
            try {
                const response = await api.get('/reports/stock-movements', {
                    params: this.reportFilter,
                    responseType: 'blob'
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `relatorio_geral_estoque.pdf`);
                document.body.appendChild(link);
                link.click();

                window.bootstrap.Modal.getInstance(document.getElementById('modalGeneralReport')).hide();
                this.showAlert("PDF gerado com sucesso!");
            } catch (e) {
                this.showAlert("Erro ao gerar relatório", "danger");
            } finally {
                this.globalLoading.hide();
            }
        },

        async exportClientsExcel() {
            this.loading = true;
            this.globalLoading.show('Gerando Planilha...');
            try {

                const response = await api.get(`/reports/stock-movements/excel`, {
                    params: this.reportFilter,
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `clientes_rmr_${Date.now()}.xlsx`);
                document.body.appendChild(link);
                link.click();

                link.remove();
                window.URL.revokeObjectURL(url);
                this.showAlert("Planilha gerada com sucesso!");
            } catch (e) {
                console.error(e);
                this.showAlert("Erro ao exportar planilha.", "error");
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        async executeMovement() {
            this.globalLoading.show('Processando operação...');
            try {
                const payload = {
                    product_id: this.selectedProductStock.id,
                    quantity: this.movementForm.quantity,
                    reason: this.movementForm.reason,
                    observations: this.movementForm.reason // Ou crie um campo específico para observations
                };

                if (this.movementForm.type === 'TRANSFER') {
                    payload.origin_branch_id = this.movementForm.origin_branch_id;
                    payload.destination_branch_id = this.movementForm.destination_branch_id;
                    await api.post('/stock-movements/transfer', payload);
                } else {
                    payload.type = this.movementForm.type;
                    payload.branch_id = this.movementForm.branch_id;

                    // AJUSTE: Verifica se o produto exige lote (Perecível OU Controle de Validade)
                    const requiresBatch = this.selectedProductStock?.is_perishable || this.selectedProductStock?.has_expiration;

                    if (requiresBatch && this.movementForm.type === 'INPUT') {
                        payload.batch_number = this.movementForm.batch_number;
                        payload.expiration_date = this.movementForm.expiration_date;
                        payload.manufacturing_date = this.movementForm.manufacturing_date;
                    }

                    await api.post('/stock-movements', payload);
                }

                this.showAlert("Estoque atualizado com sucesso!");

                // Recarrega a tabela por trás para mostrar o estoque atualizado
                this.fetchProducts(this.currentPage, false);

                window.bootstrap.Modal.getInstance(document.getElementById('modalStockMovement')).hide();
            } catch (error) {
                let msg = 'Falha ao realizar movimentação.';
                if (error.response?.data?.errors) {
                    // Pega a exata mensagem de "Estoque insuficiente" gerada pelo Service
                    msg = Object.values(error.response.data.errors)[0][0];
                } else if (error.response?.data?.message) {
                    msg = error.response.data.message;
                }
                this.showAlert(msg, 'danger');
            } finally {
                this.globalLoading.hide();
            }
        },

        async openHistoryModal(product) {
            this.selectedProductHistory = product;
            this.historyFilter = { start_date: '', end_date: '', type: 'ALL' };
            await this.fetchMovementHistory();
            const el = document.getElementById('modalMovementHistory');
            window.bootstrap.Modal.getOrCreateInstance(el).show();
        },

        async fetchMovementHistory() {
            this.globalLoading.show('Buscando extrato...');
            try {
                const res = await api.get(`/stock-movements/${this.selectedProductHistory.id}`, {
                    params: this.historyFilter
                });
                this.historyMovements = res.data.data || res.data;
            } catch (e) {
                this.showAlert("Erro ao carregar histórico de movimentações.", "danger");
            } finally {
                this.globalLoading.hide();
            }
        },

        async exportHistory(format) {
            this.globalLoading.show(`Gerando ${format.toUpperCase()}...`);
            try {
                const response = await api.get(`/stock-movements/${this.selectedProductHistory.id}/export`, {
                    params: { ...this.historyFilter, format },
                    responseType: 'blob' // Essencial para download de arquivos
                });

                const extension = format === 'pdf' ? 'pdf' : 'xlsx';
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `extrato_${this.selectedProductHistory.sku}_${Date.now()}.${extension}`);
                document.body.appendChild(link);
                link.click();

                this.showAlert(`Relatório ${format.toUpperCase()} gerado!`);
            } catch (e) {
                this.showAlert("Erro ao exportar arquivo.", "danger");
            } finally {
                this.globalLoading.hide();
            }
        },

        formatDate(data) {
            if (!data) return '-';
            const somenteData = data.split('T')[0].split(' ')[0];
            const partes = somenteData.split('-');
            if (partes.length === 3) {
                return `${partes[2]}/${partes[1]}/${partes[0]}`;
            }

            try {
                return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
            } catch (e) {
                return data;
            }
        },

        clearHistoryFilters() {
            this.historyFilter = {
                start_date: '',
                end_date: '',
                type: 'ALL',
                exp_start: '',
                exp_end: ''
            };
            this.fetchMovementHistory();
        },

        openImportModal() {
            this.resetImport();
            if (!this.modalImportInstance) {
                this.modalImportInstance = new window.bootstrap.Modal(document.getElementById('modalImportPreview'));
            }
            this.modalImportInstance.show();
        },

        resetImport() {
            this.importPreviewData = [];
            this.importFileObject = null;
            this.importErrors = [];
            this.importDuplicates = [];
            if (this.$refs.fileInputImport) this.$refs.fileInputImport.value = '';
        },

        handleFilePreview(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.importFileObject = file;
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rawJson = XLSX.utils.sheet_to_json(worksheet);

                const errors = [];

                this.importPreviewData = rawJson.map((row, index) => {
                    const excelRow = index + 2;

                    // 🌟 BLINDAGEM DAS CHAVES: Aceita o formato do banco ou o formato amigável
                    const skuVal = row['sku'] || row['SKU'] || row['Sku'];
                    const nomeVal = row['nome_do_produto'] || row['Nome do Produto'] || row['nome'] || row['Nome'];
                    const precoVal = row['preco'] || row['Preço'] || row['Preco'] || row['valor'];

                    const rowData = {
                        excelRow: excelRow,
                        sku: skuVal || '---',
                        nome: nomeVal || '---',
                        preco: precoVal || '---',
                        categoria: row['categoria'] || row['Categoria'] || '---',
                        estoque: row['estoque'] || row['Estoque'] || 0,
                        unid_medida: row['unid_medida'] || row['Unidade'] || 'UN',
                        codigo_de_barras: row['codigo_de_barras'] || row['Código de Barras'] || '---'
                    };

                    // Validação interna do Front-end
                    const missingFields = [];
                    if (!skuVal || skuVal === '---') missingFields.push('SKU');
                    if (!nomeVal || nomeVal === '---') missingFields.push('Nome');
                    if (!precoVal || precoVal === '---') missingFields.push('Preço');

                    if (missingFields.length > 0) {
                        errors.push({ linha: excelRow, campos: missingFields.join(', ') });
                    }

                    rowData.isInvalid = missingFields.length > 0;
                    rowData.errorsList = missingFields.join(', ');

                    return rowData;
                });

                this.importErrors = errors;
            };
            reader.readAsArrayBuffer(file);
        },

        async executeFinalImport() {
            if (!this.importFileObject) return;

            this.loadingImport = true;
            const fd = new FormData();
            fd.append('file', this.importFileObject);

            try {
                await api.post('/products/import', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                this.showAlert("Importação enfileirada com sucesso!");
                this.modalImportInstance.hide();
                this.fetchProducts(1, false);
            } catch (e) {
                this.showAlert("Erro ao processar arquivo no servidor.", "danger");
            } finally {
                this.loadingImport = false;
            }
        },

        downloadImportTemplate() {
            const link = document.createElement('a');
            link.href = '/templates/modelo_importacao_produtos.xlsx';
            link.setAttribute('download', 'modelo_importacao_produtos_rmr.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        refreshData() {
            this.fetchProducts(1, false);
        },

        isGlobalStockCritical(item) {
            if (!item.branches || item.branches.length === 0) return false;
            // Retorna true se houver ao menos uma filial com estoque real abaixo ou igual ao mínimo dela
            return item.branches.some(branch => Number(branch.pivot.stock) <= Number(branch.pivot.min_stock));
        }

    }
}
</script>

<style scoped>
.main-content {
    background: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
}

/* FIX: SCROLL DROPDOWN */
.table-container {
    overflow: visible !important;
}

.btn-pmg-icon {
    background-color: #f1f5f9;
    border: none;
    color: #475569;
    border-radius: 8px;
    padding: 6px 10px;
}

.dropdown-menu {
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
    min-width: 200px;
}

.scrollable-menu {
    max-height: 200px;
    overflow-y: auto;
}

.btn-pmg-icon {
    background: none;
    border: none;
    color: #94a3b8;
    padding: 10px;
    border-radius: 10px;
}

.btn-pmg-icon:hover {
    background: #f1f5f9;
    color: #561569;
}

/* TABELA */
.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

/* FORMS E ABAS */
.form-control-pmg {
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 14px;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 3px rgba(33, 51, 97, 0.1);
}

.pmg-tabs .nav-link {
    border: none;
    color: #94a3b8;
    font-weight: 700;
    padding: 12px 20px;
    border-bottom: 3px solid transparent;
}

.pmg-tabs .nav-link.active {
    color: #561569;
    border-bottom-color: #561569;
}

/* INPUT GROUP FIX PARA MOEDA */
.input-group-text {
    border-radius: 12px 0 0 12px;
    border: 1px solid #e2e8f0;
    padding-left: 1rem;
    padding-right: 0.5rem;
}

.input-group .form-control-pmg {
    border-radius: 0 12px 12px 0;
}

.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}


/* Estilo para a Linha do Tempo Vertical */
.timeline {
    position: relative;
    padding-left: 1rem;
}

.timeline::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 5px;
    bottom: 0;
    width: 2px;
    background: #e2e8f0;
    /* Cor da linha vertical */
}

.timeline-item {
    position: relative;
}

.timeline-marker {
    position: absolute;
    left: -16px;
    top: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #561569;
    /* Cor azul PMG */
    border: 2px solid #fff;
    z-index: 1;
}

.timeline-item:last-child {
    padding-bottom: 0 !important;
}

/* Container de Scroll da Auditoria */
.audit-scroll-container {
    max-height: 450px;
    /* Altura máxima antes de começar o scroll */
    overflow-y: auto;
    /* Habilita o scroll vertical */
    overflow-x: hidden;
    padding-right: 10px;
    /* Espaço para a barra não ficar em cima do conteúdo */
}

/* Customização da Barra de Rolagem (Webkit - Chrome/Edge/Safari) */
.audit-scroll-container::-webkit-scrollbar {
    width: 6px;
}

.audit-scroll-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
}

.audit-scroll-container::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

.audit-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #561569;
    /* Cor da marca RMR ao passar o mouse */
}

/* Estilo para a Linha do Tempo (mantido com ajuste de margem) */
.timeline {
    position: relative;
    padding-left: 1rem;
    margin-top: 5px;
}


/* FIX PARA DROPDOWN NÃO SUMIR */
.table-responsive {
    overflow: visible !important;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

/* Transições */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

#modalMovementHistory .table-responsive {
    overflow-x: auto !important;
    overflow-y: auto !important;
    border: 1px solid #e2e8f0;
    scrollbar-width: thin;
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border-radius: 12px !important;
    padding: 10px 24px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.btn-pmg-primary,
.btn-pmg-light,
.btn-pmg-danger {
    padding: 10px 24px !important;
    /* Aumentamos um pouco o preenchimento lateral */
    border-radius: 10px;
    font-weight: 500;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    height: 45px;
    /* Fixamos a altura para garantir simetria total */
}

/* Cores específicas para o Primary */
.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
}

.btn-pmg-primary:hover {
    background: #1a294d;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(33, 51, 97, 0.2);
}


.btn-pmg-light {
    border-radius: 12px !important;
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    font-weight: 500;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}
</style>